import axios, { rawAxios } from "./axios";
import { v4 as uuidv4 } from "uuid";

const UPLOAD_ENDPOINT = "/upload-file";

export const uploadFile = async (file, moduleNumber, mimeType = "") => {
	let downloadUrl = null;
	const fileName = `${Date.now()}-${uuidv4()}.${file.name.split(".")[file.name.split(".").length - 1]
		}`;

	try {
		const urlsResp = await axios.post(UPLOAD_ENDPOINT, {
			file_name: `${fileName}`,
			module: moduleNumber,
			mime_type: mimeType || file?.type
		});

		const requestConfig = {
			headers: {
				"Content-Type": mimeType || file?.type,
				"Access-Control-Allow-Origin": "*"
			}
		};
		await rawAxios.put(urlsResp.data.upload.url, file, requestConfig);
		downloadUrl = urlsResp.data.download.url;
	} catch (err) {
		throw new Error(err);
	}

	return downloadUrl;
};

export const multipleUploadImages = async (
	file,
	moduleNumber,
	mimeType = "",
	onProgress,
) => {
	let downloadUrl = null;
	const fileName = `${Date.now()}-${uuidv4()}.${file.name.split(".").pop()}`;

	try {
		const urlsResp = await axios.post(UPLOAD_ENDPOINT, {
			file_name: fileName,
			module: moduleNumber,
			mime_type: mimeType || file?.type,
		},
		);

		const requestConfig = {
			headers: {
				"Content-Type": mimeType || file?.type,
				"Access-Control-Allow-Origin": "*",
			},
			onUploadProgress: (progressEvent) => {
				if (onProgress) {
					const percentCompleted = Math.round(
						(progressEvent.loaded * 100) / progressEvent.total
					);
					onProgress(percentCompleted); // Report the individual file's progress
				}
			},
		};

		await rawAxios.put(urlsResp.data.upload.url, file, requestConfig);
		downloadUrl = urlsResp.data.download.url;
	} catch (err) {
		throw new Error(err);
	}

	return downloadUrl;
};
